import React from "react";
import { biographyParagraphs, portraitImage, education } from "../mock/mock";
import useReveal from "../hooks/useReveal";

const Biography = () => {
  const ref = useReveal();
  return (
    <section id="biography" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6" ref={ref}>
        <div id="about" className="grid lg:grid-cols-2 gap-14 items-start">
          {/* Portrait */}
          <div className="reveal relative">
            <div className="absolute -top-5 -left-5 w-32 h-32 border-t-4 border-l-4 border-[#c8a15a] rounded-tl-2xl" />
            <img
              src={portraitImage}
              alt="Kyle D. Gobel, Attorney at Law"
              className="relative rounded-2xl w-full object-cover shadow-2xl aspect-[4/5]"
            />
          </div>

          {/* Text */}
          <div className="reveal" style={{ animationDelay: "120ms" }}>
            <span className="inline-block text-[#c8a15a] uppercase tracking-[0.3em] text-xs font-semibold mb-4">
              Meet Your Attorney
            </span>
            <h2 className="font-display text-3xl md:text-5xl font-bold text-[#14213d] mb-6">
              Kyle D. Gobel
            </h2>
            <div className="space-y-4 text-slate-600 leading-relaxed">
              {biographyParagraphs.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
          </div>
        </div>

        {/* Timeline */}
        <div className="mt-20">
          <h3 className="font-display text-2xl md:text-3xl font-bold text-[#14213d] mb-10 text-center">
            Education & Career
          </h3>
          <div className="grid md:grid-cols-5 gap-6">
            {education.map((e, i) => (
              <div
                key={i}
                className="reveal relative bg-[#f7f5f0] rounded-xl p-6 border-t-4 border-[#c8a15a]"
                style={{ animationDelay: `${i * 80}ms` }}
              >
                <div className="font-display text-2xl font-bold text-[#c8a15a] mb-2">
                  {e.year}
                </div>
                <div className="font-semibold text-[#14213d] mb-1">{e.title}</div>
                <div className="text-sm text-slate-600">{e.detail}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Biography;
